import BadTypCdSelect from "components/select/rm/badTypCd";
import RmOlkCdSlect from "components/select/rm/rmOlkCd";
import RmTypCdSelect from "components/select/rm/rmTypCd";
import {
  CREATE_BASE_FORM_ID_ROOM_ROOM,
  UPDATE_BASE_FORM_ID_ROOM_ROOM,
} from "components/constent";
import TableRow from "components/rows/tableRow";
import Cell from "components/rows/cell";
import LodInfRow from "components/rows/lodRow";
import Radio from "components/rows/radio";
import { IRmInf } from "interface/rm/rm";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import { useBaseSubmitForm } from "./service";

type IProps = {
  baseInf: IRmInf | null;
  formTyp: "create" | "update" | "read";
};

export default function BaseInfForm({ baseInf, formTyp }: IProps) {
  const { t } = useTranslation();
  const lnagCd = i18n.language;

  /**
   * 상세조회, 생성일때 기본정보 생성 후  R
   * 생성, 수정 , 수정완료 후 C
   */
  const dataTyp =
    formTyp === "read" || (formTyp === "create" && baseInf) ? "R" : "C";

  const isRequired = formTyp === "create" ? "dot" : "";
  const updateAble = formTyp === "update" ? "true" : "false";

  const formId =
    formTyp === "create"
      ? CREATE_BASE_FORM_ID_ROOM_ROOM
      : formTyp === "update"
      ? UPDATE_BASE_FORM_ID_ROOM_ROOM
      : "";

  const { onBaseSubmit } = useBaseSubmitForm();

  return (
    <form id={formId} data-type={formTyp} onSubmit={onBaseSubmit}>
      <table>
        <tbody>
          <LodInfRow />
          <TableRow title={t("row_ttl_default")}>
            <ul>
              {baseInf?.rmNo && (
                <li>
                  <Cell label={"객실번호"} value={baseInf.rmNo} dataTyp="R" />
                </li>
              )}
              <li>
                <label htmlFor={isRequired}>{t("lbl_rm_typ")}</label>
                <RmTypCdSelect
                  dataTyp={dataTyp}
                  isUpdateAble={updateAble === "true"}
                  defaultValue={{
                    ko: lnagCd === "ko" ? baseInf?.rmTypNm : "",
                    en: lnagCd === "en" ? baseInf?.rmTypNm : "",
                    code: baseInf?.rmTypCd ?? "",
                    value: baseInf?.rmTypCd ?? "",
                  }}
                />
              </li>
              <li>
                <label htmlFor={isRequired}>{t("lbl_rm_olk")}</label>
                <RmOlkCdSlect
                  dataTyp={dataTyp}
                  isUpdateAble={updateAble === "true"}
                  defaultValue={{
                    ko: lnagCd === "ko" ? baseInf?.rmOlkNm : "",
                    en: lnagCd === "en" ? baseInf?.rmOlkNm : "",
                    code: baseInf?.rmOlkCd ?? "",
                    value: baseInf?.rmOlkCd ?? "",
                  }}
                />
              </li>
              <li>
                <label htmlFor={isRequired}>{t("lbl_bad_typ")}</label>
                <BadTypCdSelect
                  dataTyp={dataTyp}
                  isUpdateAble={updateAble === "true"}
                  defaultValue={{
                    ko: lnagCd === "ko" ? baseInf?.bedTypNm : "",
                    en: lnagCd === "en" ? baseInf?.bedTypNm : "",
                    code: baseInf?.bedTypCd ?? "",
                    value: baseInf?.bedTypCd ?? "",
                  }}
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_max_per_ct")}
                  labelFor={isRequired}
                  name="maxPerCt"
                  value={baseInf?.maxPerCt ?? ""}
                  dataTyp={dataTyp}
                  updateAble={updateAble}
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_min_per_ct")}
                  name="minPerCt"
                  value={baseInf?.minPerCt ?? ""}
                  dataTyp={dataTyp}
                  updateAble={updateAble}
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_rm_area")}
                  name={"rmAreaDesc"}
                  value={baseInf?.rmAreaDesc ?? ""}
                  dataTyp={dataTyp}
                  updateAble={updateAble}
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_chld_fee_per_ct")}
                  name="chldFreePerCt"
                  value={baseInf?.chldFreePerCt ?? ""}
                  dataTyp={dataTyp}
                  updateAble={updateAble}
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_baby_fee_per_ct")}
                  value={baseInf?.babyFreePerCt ?? ""}
                  name="babyFreePerCt"
                  dataTyp={dataTyp}
                  updateAble={updateAble}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_uyn")}</label>
                <div className="flex">
                  <Radio
                    label={t("uyn_y")}
                    id={"Y"}
                    name={"uyn"}
                    checked={baseInf ? baseInf.uyn === "Y" : true}
                    dataTyp={dataTyp}
                    updateAble={updateAble}
                  />
                  <Radio
                    label={t("uyn_n")}
                    id={"N"}
                    checked={baseInf?.uyn === "N"}
                    name={"uyn"}
                    dataTyp={dataTyp}
                    updateAble={updateAble}
                  />
                </div>
              </li>
            </ul>
          </TableRow>
        </tbody>
      </table>
    </form>
  );
}
